import React from 'react'

import { Form, Col } from '_zari/core'

const MonedaFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='input-moneda' xs={12} />
      <Col xs={12}>
        <Form.InputText defaultValue={iValue} disabled id='input-moneda' name='moneda' />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
